import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

import GameField from './components/GameField';

class App extends Component {
  render() {
    return (
      <GameField />
    );
  }
}

export default App;
